import { useEffect, useState, type ReactNode } from 'react';
import { Dropdown as AntDropdown } from 'antd';
import classNames from 'classnames';
import { useFela } from 'react-fela';

import type { TRuleWithTheme } from '@/styles/theme';

import * as felaRules from './Dropdown.rules';
import { DropdownButton } from './DropdownButton';

export interface DropdownProps {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    items: {
        key: string;
        active: boolean;
        label: ReactNode;
        onClick?: () => void;
        disabled?: boolean;
    }[];
    children: ReactNode;
    customStyle?: typeof felaRules.dropdown;
    customButtonStyle?: TRuleWithTheme;
}

export const Dropdown = ({ open = false, onOpenChange, items, children, customStyle, customButtonStyle }: DropdownProps) => {
    const { css } = useFela();
    const [visible, setVisibility] = useState(open);

    useEffect(() => {
        setVisibility(open);
    }, [open]);

    return (
        <AntDropdown
            classNames={{ root: css(felaRules.dropdown, customStyle) }}
            // @ts-expect-error
            getPopupContainer={triggerNode => triggerNode.parentElement}
            open={visible}
            onOpenChange={o => {
                setVisibility(o);
                onOpenChange?.(o);
            }}
            trigger={['hover']}
            placement='bottom'
            menu={{
                items: items.map(item => ({
                    key: item.key,
                    label: item.label,
                    className: classNames({
                        active: item.active,
                    }),
                    disabled: item.disabled,
                    onClick: () => {
                        if (item.disabled) return;
                        item.onClick?.();
                        setVisibility(false);
                    },
                })),
            }}
        >
            <DropdownButton open={visible} customStyle={customButtonStyle}>
                {children}
            </DropdownButton>
        </AntDropdown>
    );
};
